namespace Matrix.Workflow {
    export interface ClientFunctionRow {
        FunctionName?: string;
        Description?: string;
        TriggerType?: string;
        TriggerDefinition?: string;
        Parameters?: string;
        GroupName?: string;
        DisplayOrder?: number;
        Enabled?: boolean;
        Permission?: string;
        Runnable?: boolean;
        Rerunnable?: boolean;
        LastInvocationId?: number;
        LastStatusCode?: string;
        LastStarted?: string;
        LastFinished?: string;
        LastDuration?: number;
        NextExecution?: string;
        WorkflowInstanceId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ClientFunctionRow {
        export const idProperty = 'FunctionName';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Workflow.ClientFunction';
        export const lookupKey = 'Workflow.ClientFunction';

        export function getLookup(): Q.Lookup<ClientFunctionRow> {
            return Q.getLookup<ClientFunctionRow>('Workflow.ClientFunction');
        }
        export const deletePermission = 'DataAdmin:ClientFunction';
        export const insertPermission = 'DataAdmin:ClientFunction';
        export const readPermission = 'Read:ClientFunction';
        export const updatePermission = 'DataAdmin:ClientFunction';

        export declare const enum Fields {
            FunctionName = "FunctionName",
            Description = "Description",
            TriggerType = "TriggerType",
            TriggerDefinition = "TriggerDefinition",
            Parameters = "Parameters",
            GroupName = "GroupName",
            DisplayOrder = "DisplayOrder",
            Enabled = "Enabled",
            Permission = "Permission",
            Runnable = "Runnable",
            Rerunnable = "Rerunnable",
            LastInvocationId = "LastInvocationId",
            LastStatusCode = "LastStatusCode",
            LastStarted = "LastStarted",
            LastFinished = "LastFinished",
            LastDuration = "LastDuration",
            NextExecution = "NextExecution",
            WorkflowInstanceId = "WorkflowInstanceId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
